import { useEffect } from "react"
import { useLocation } from "react-router-dom"

/** Marketing pages link to in-page sections via `/#section-id` (nav, footer,
 *  CTAs). React Router's client-side navigation never triggers the browser's
 *  native hash scroll, so without this those links silently do nothing --
 *  both on first load and when clicked from the same page. */
export function useScrollToHash() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (!hash) return
    document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth", block: "start" })
  }, [pathname, hash])
}
